import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { SearchStrengthRequest } from '../types';
import { usePostCoachingCreateCoachingStrengthMutation, useGetCoachingCoachingStrengthQuery } from '../strengthSlice';

interface CarryForwardStrengthsProps {
    inputMonth: number | undefined;
    inputYear: number | undefined;
    receiverId: string;
    authorId: string;
    onHide: () => void;
}

const CarryForwardStrengths = (props: CarryForwardStrengthsProps) => {
    const [CreateStrength] = usePostCoachingCreateCoachingStrengthMutation();
    const [currentMonthName, setCurrentMonthName] = useState('');
    const [previousMonthName, setPreviousMonthName] = useState('');
    const [previousMonthNumber, setPreviousMonthNumber] = useState(0);
    const [strneghtsList, setStrengthLIst] = useState<any>([]);
    const [previousYear, setPreviousYear] = useState(0);
    useEffect(() => {
        // Function to get the current and previous month names
        const getMonthNames = () => {
            if (typeof props.inputMonth === 'number' && typeof props.inputYear === 'number') {
                const date = new Date(props.inputYear, props.inputMonth - 1, 1);
                const currentMonthName = date.toLocaleString('default', { month: 'long' });
                setCurrentMonthName(currentMonthName);

                date.setMonth(date.getMonth() - 1);
                const previousMonthName = date.toLocaleString('default', { month: 'long' });
                setPreviousMonthName(previousMonthName);
                setPreviousMonthNumber(date.getMonth() + 1); // Adding 1 because getMonth() returns zero-based index
                setPreviousYear(date.getFullYear());
            }
        };

        // Call the function when the component mounts
        getMonthNames();
    }, [props.inputMonth, props.inputYear]);

    const initParams = () => {
        // add keys only if value exists
        const params: SearchStrengthRequest = {
            employeeNumber: props.receiverId,
        };

        if (props.authorId) {
            params.authorEmployeeNumber = props.authorId;
        }

        params.month = previousMonthNumber;
        params.year = previousYear;

        return params;
    };

    const { data: strengths } = useGetCoachingCoachingStrengthQuery(initParams(), { skip: !previousMonthNumber || !previousYear });

    useEffect(() => {
        setStrengthLIst(strengths?.data || []);
    }, [strengths?.data]);


    const handleClickYes = () => {
        let array = []
        array = strneghtsList.map((item: any) => {
            return {
                employeeNumber: props.receiverId,
                authorEmployeeNumber: props.authorId,
                strengthDescription: item.strength_description,
                strengthTitle: item.strength_title,
                coreValueId: item.core_value_id,
                year: props.inputYear,
                month: props.inputMonth,
            }
        })

        CreateStrength({ createCoachingStrength: array })
            .unwrap()
            .then((res: any) => {
                if (res?.data) {
                    toast.success('Strength saved successfully');
                    props.onHide();
                } else toast.error('Something went wrong');
            })
            .catch((error: any) => {
                toast.error(error);
            });
    }
    const handleClickCancel = () => {
        props.onHide();
    }
    return (
        <div>
            {strneghtsList.length > 0 ? (
                <>
                    <div className='m-top-10'>
                        You have an entry for {previousMonthName}. Would you like to make that active for {currentMonthName}
                    </div>
                    <div className='flexButtons m-top-10'>
                        <Button
                            className="btn-secondary me-2"
                            onClick={handleClickCancel}
                            label={"Cancel"}
                        />
                        <Button
                            className="btn-primary"
                            onClick={handleClickYes}
                            label={"Carry Forward"}
                        />

                    </div>
                </>
            ) : (
                <>
                    <div className='m-top-10'>
                    <div className='m-top-10'>You don&apos;t have entry for {previousMonthName} create a new one</div>
                    </div>
                    <div className='flexButtons m-top-10'>
                        <Button
                            className="btn-primary"
                            onClick={handleClickCancel}
                            label={"Ok"}
                        />
                    </div>
                </>
            )}
        </div>

    )
}

export default CarryForwardStrengths;